import { Component } from 'react'
import { ReactP5Wrapper } from "react-p5-wrapper";
import sketchTypewriter from '../components/SketchPredeterminateTypewriter';

export default class JustLikeYou extends Component {
    render() {
        return(
            <div className="neortCanvas">
                <ReactP5Wrapper sketch={sketchTypewriter}/>
            </div>
        )
    }
}